import { LoadingOutlined } from "@ant-design/icons";
import { Radio, Spin } from "antd";
import Button from "../../../../components/FormElements/Button";
import { useSelector } from "react-redux";
import { cardImageSelector } from "../../../../config/utils/CardImageSelector";
import { useState } from "react";



const PaymentCardsSelection = ({ cardSelectionHandler, adSumbitLoading }) => {

    const [selectedCreditCardProvider, setSelectedCreditCardProvider] = useState('');
    const { loading, cards, error } = useSelector(state => state?.payments);

    const handleCreditCardProviderSelection = (e) => {
        setSelectedCreditCardProvider(e?.target?.value)
    }

    const handleSubmit = () => {
        cardSelectionHandler(selectedCreditCardProvider)
    }

    return (
        <div className='w-full my-6 flex gap-1 items-center flex-wrap'>
            {
                loading ?
                    <Spin indicator={<LoadingOutlined loading />} size="default" />
                    :
                    cards && cards?.length > 0 ?
                        <Radio.Group className='flex sm:flex-row flex-col gap-2 flex-wrap' onChange={handleCreditCardProviderSelection} value={selectedCreditCardProvider}>
                            {cards?.map((card) => (
                                <div
                                    className={`bg-gray-100 p-2 flex justify-between w-fit mb-2 gap-5`}
                                    key={'card' + card?.id}
                                >
                                    <div className='flex flex-nowrap px-4 gap-4'>
                                        <div className='flex items-center'>
                                            <img src={cardImageSelector(card?.brand)} alt='credit card provider icon' className='img-fluid w-[50px]' />
                                        </div>
                                        <div className='flex flex-col gap-0'>
                                            <h6 className='heading-6 font-bold mb-1'>
                                                {card?.brand}
                                            </h6>
                                            <p className='text-xs flex flex-row gap-1'>**** **** **** <span>{card?.last4}</span></p>
                                        </div>
                                    </div>
                                    <Radio value={card?.id} className=''></Radio>
                                </div>
                            ))}
                        </Radio.Group>
                        :
                        <p>No cards attached.</p>
            }
            <Button.Basic
                onClick={handleSubmit}
                disabled={false}
                icon={null}
                loading={adSumbitLoading}
                type="primary"
                size='medium'
                text='Confirm Payment'
                className='p-3 h-10 mt-3 rounded-md outline-none border-none bg-[#fab700] text-white ad-btn'
            />
        </div>

    )
}

export default PaymentCardsSelection